/**
 * Full JSON-LD schema array for /about/performance: one VideoObject per
 * embedded live-performance video (the #34 convention every video-bearing
 * page follows). uploadDate uses the noon-UTC date-only form — see
 * loadYoutubeUploadDates in scripts/build-blog.mts for why midnight-Z trips
 * GSC.
 *
 * Previously lived inline in app.routes.ts's static route data. Moved here
 * 2026-09-14 (same pass as testimonials/bio) so it's set at runtime via
 * SEOService — see PerformanceContentComponent — inside this route's own
 * lazy chunk instead of the eager route-data bundle.
 */
export function buildPerformancePageSchemas(): Record<string, unknown>[] {
  return [
    {
      '@type': 'VideoObject',
      name: 'Days Of Wine And Roses at the Green Island Lounge',
      description:
        'Live jazz performance with Russ Rodgers on bass at the Green Island Lounge, October 2025.',
      thumbnailUrl: 'https://i.ytimg.com/vi/iNouBEOeOhU/hqdefault.jpg',
      uploadDate: '2025-10-11T12:00:00+00:00',
      duration: 'PT9M37S',
      contentUrl: 'https://www.youtube.com/watch?v=iNouBEOeOhU',
      embedUrl: 'https://www.youtube.com/embed/iNouBEOeOhU',
    },
    {
      '@type': 'VideoObject',
      name: 'Jazz set at JoJo in Washington, DC',
      description:
        'Live jazz performance with Russ Rodgers on bass at JoJo in Washington, DC, July 2025.',
      thumbnailUrl: 'https://i.ytimg.com/vi/u5DPEdXvI5I/hqdefault.jpg',
      uploadDate: '2025-07-21T12:00:00+00:00',
      duration: 'PT2M48S',
      contentUrl: 'https://www.youtube.com/watch?v=u5DPEdXvI5I',
      embedUrl: 'https://www.youtube.com/embed/u5DPEdXvI5I',
    },
    {
      '@type': 'VideoObject',
      name: 'Key To The Highway with the Bobby Thompson Group',
      description:
        'Live blues performance with Russ Rodgers on bass, with the Bobby Thompson Group, June 2025.',
      thumbnailUrl: 'https://i.ytimg.com/vi/ntedE6BPjaM/hqdefault.jpg',
      uploadDate: '2025-07-06T12:00:00+00:00',
      duration: 'PT8M6S',
      contentUrl: 'https://www.youtube.com/watch?v=ntedE6BPjaM',
      embedUrl: 'https://www.youtube.com/embed/ntedE6BPjaM',
    },
    {
      '@type': 'VideoObject',
      name: 'Get Down with Swamp Dog',
      description:
        'Live blues performance with Russ Rodgers on bass, with Swamp Dog, July 2025.',
      thumbnailUrl: 'https://i.ytimg.com/vi/iYnR9qSGY0I/hqdefault.jpg',
      uploadDate: '2025-07-23T12:00:00+00:00',
      duration: 'PT5M22S',
      contentUrl: 'https://www.youtube.com/watch?v=iYnR9qSGY0I',
      embedUrl: 'https://www.youtube.com/embed/iYnR9qSGY0I',
    },
  ];
}
